<template>
    <transition name="fade">
        <div class="modal" :class="{'show':modal_show}" tabindex="-1" aria-hidden="true" v-if="modal_show">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">{{title}} Content</h5>
                        <button type="button" class="btn btn-round close" @click="close">
                            <i class="mdi mdi-close"></i>
                        </button>
                    </div>
                    <div class="modal-body p-3">
                        <div class="form-group">
                            <label class="fw-700 text-dark opacity-8 mb-2">Type</label>
                            <select class="form-select fw-600 text-muted me-2 w-full" v-model="data.data.type">
                                <option :value="types.value"  ref="type" v-for="types in type_opt" :key="types.value">
                             
                                    {{ types.label }}
                                </option>
                            </select>
                        </div>
                        <div class="form-group">
                            <label class="fw-700 text-dark opacity-8 mb-2">Title</label>
                            <input type="text" class="form-control fs-14 form-control-lg custom-input" ref="title" :value="(data.hasOwnProperty.call(data, 'data') ? data.data.title : '')" />
                        </div>

                        <div class="form-group">
                            <label class="fw-700 text-dark opacity-8 mb-2"> URL </label>
                            <input type="text" class="form-control fs-14 form-control-lg custom-input" ref="content" :value="(data.hasOwnProperty.call(data, 'data') ? data.data.content : '')" />
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn text-primary" @click="exec">{{title}}</button>
                        <button type="button" class="btn" @click="close">Close</button>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>

export default {
    data() {
        return {
            modal_show: false,
            data:'',
            type_opt : [{
                label : "Video",
                value : "video"
            },
            {
                label : "Link",
                value : "link"
            }
        ]
        }
    },
    computed: {
        title() {
            // return (this.data.hasOwnProperty.call(this.data, 'data') == '' ? 'Add' : 'Update');
            // return this.data.hasOwnProperty.call(this.data.data, 'add') == true ? 'Add' : 'Update'

            if(this.data.hasOwnProperty.call(this.data.data, 'add')) {
                return 'Add'
            }
            return 'Update'
        },

    },
    methods: {
        close() {
            this.modal_show = false;
            this.data = '';
        },
        exec() {
            if(typeof this.data !== 'object') return;




            
            if(this.data.hasOwnProperty.call(this.data, 'callback')) {
                if(typeof this.data.callback === 'function') {
                    this.data.callback((this.data.hasOwnProperty.call(this.data, 'data') ? this.data.data.index : null), this.$refs.title.value, this.$refs.content.value,this.data.data.type);
                    this.close();
                }
            }
        }
    },
    mounted() {
        this.$emitter.on('show_add_vu', (data) => {

            this.modal_show = true;
            if(data !== undefined) {
                this.data = data;

                if(!('data' in data)){
                    console.log(data.data)

                    this.data.data =  {
                            content : '',
                            title : '',
                            type : '',
                            add : true
                        };

                }
      
            }
            else this.data = ''
        });
    }
}
</script>

<style scoped>
.modal::after {
    background: #000;
    content: '';
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    z-index: -1;
    opacity: 0.5;
}

.modal.show {
    display: block;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.1s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}


.text-primary {
    color: var(--primary-color) !important;
}
</style>